export const TABLET = '(max-width: 1265px)';



// WEBPACK FOOTER //
// ./src/app/ui/style/common/breakpoints.js